<template>
    <div>
        <h3>バックアップする</h3>
        <div>
            <p>
                貸し本棚に登録した小説は、２種類の方法でバックアップすることができます。
            </p>
            <p>
                ひとつは手動で小説データをダウンロードすること。
                もうひとつは自動で登録メールアドレスにバックアップファイルを送信することです。
                いずれも小説情報、本文、ノートを含みますが、表紙画像は含みません。
            </p>
            <p>
                小説データは作者様の大切な資産です。
                貸し本棚はデータベースの定期的なバックアップによって情報の保全を行っていますが、
                作者様自身の手によって、必ずバックアップすることをお勧めします。
            </p>

            <h4>小説データをダウンロードする</h4>
            <img src="/img/help/novel/16.png" alt="全文ダウンロード" class="img-thumbnail mb-3">
            <p>
                小説の本文一覧画面に「全文ダウンロード」ボタンがあります。
                これをクリックすると、「UTF-8+LF」形式、あるいは「Shift_JIS+CRLF」形式での選択がドロップダウンします。
                いずれかの形式を選択すると、指定した文字コード＋改行コードで小説情報、すべての本文、ノートをテキストファイルに出力し、
                zipアーカイブにしてダウンロードします。
            </p>
            <p>
                全文ダウンロードには「EPUB」形式があります。
                これは電子書籍のレイアウト確認用で、バックアップ用ではありません。
            </p>

            <h4>メールバックアップする</h4>
            <img src="/img/help/novel/17.png" alt="メールバックアップ" class="img-thumbnail mb-3">
            <p>
                小説情報の編集画面に「メールバックアップ」の項目があります。
                ここで「バックアップする」を選択して保存することで、
                <strong>24時間以内に小説情報、あるいは本文が更新された場合</strong>、
                午前５時ごろにバックアップを送信します。
                バックアップ処理が５時頃に実行されるため、前日の午前５時以降に更新された小説がバックアップの対象となります。
            </p>
            <p>
                メールアドレスが未登録、あるいはメールアドレスがRFCに準拠しない形式の場合、バックアップの設定ができません。
            </p>
            <p>
                バックアップする、を設定したとき、その時点で小説情報が更新されるため、本文を更新しなくても、
                バックアップメールは必ず１回送信されます。
            </p>
            <p>
                メールバックアップは送信先メールボックスの検証を行いません。
                メールが戻ってきたり、スパム扱いされていたり、メールボックスがいっぱいになっていた場合でも、
                バックアップメール送信を中断することはありません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "バックアップする | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>